export default function initCounter() {
  Alpine.data('counter', () => ({
    startDate: new Date(),
    now: new Date(),

    translates: [],

    years: 0,
    days: 0,
    daysText: 'Days',
    hours: '00',
    hoursText: 'Hours',
    minutes: '00',
    minutesText: 'Minutes',
    seconds: '00',
    secondsText: 'Seconds',

    init() {
      const startAttr = this.$el.getAttribute('data-start');
      if (!startAttr) {
        return;
      }
      this.translates = JSON.parse(this.$el.getAttribute('data-translates') ?? '');
      this.startDate = new Date(startAttr);

      this.update(); // initial
      setInterval(() => this.update(), 1000);
    },

    update() {
      const now = new Date();
      const start = this.startDate;
      const temp = new Date(start);

      // Years
      this.years = now.getFullYear() - start.getFullYear();
      temp.setFullYear(start.getFullYear() + this.years);
      if (temp > now) {
        this.years -= 1;
        temp.setFullYear(start.getFullYear() + this.years);
      }

      // Days
      this.computeDaysSinceAnniversary(now);
      let diffInSeconds = Math.floor((now.getTime() - temp.getTime()) / 1000);
      diffInSeconds %= 86400;

      // Hours
      const hoursNum = Math.floor(diffInSeconds / 3600);
      if (hoursNum === 1) {
        // @ts-ignore
        this.hoursText = this.translates.hour ?? 'Hour';
      } else {
        // @ts-ignore
        this.hoursText = this.translates.hours ?? 'Hours';
      }
      // Pad hours with leading zero if single digit
      this.hours = hoursNum.toString().padStart(2, '0');
      diffInSeconds %= 3600;

      // Minutes
      const minutesNum = Math.floor(diffInSeconds / 60);
      if (minutesNum === 1) {
        // @ts-ignore
        this.minutesText = this.translates.minute ?? 'Minute';
      } else {
        // @ts-ignore
        this.minutesText = this.translates.minutes ?? 'Minutes';
      }
      // Pad minutes with leading zero if single digit
      this.minutes = minutesNum.toString().padStart(2, '0');

      // Seconds
      const secondsNum = diffInSeconds % 60;
      if (secondsNum === 1) {
        // @ts-ignore
        this.secondsText = this.translates.second ?? 'Second';
      } else {
        // @ts-ignore
        this.secondsText = this.translates.seconds ?? 'Seconds';
      }
      // Pad seconds with leading zero if single digit
      this.seconds = secondsNum.toString().padStart(2, '0');
    },

    computeDaysSinceAnniversary(now: Date) {
      const start = this.startDate;

      const currentYear = now.getFullYear();
      const anniversaryThisYear = new Date(
        currentYear,
        start.getMonth(),
        start.getDate(),
        start.getHours(),
        start.getMinutes(),
        start.getSeconds(),
      );

      let fromDate;
      if (now >= anniversaryThisYear) {
        fromDate = anniversaryThisYear;
      } else {
        // Go back to anniversary last year
        fromDate = new Date(
          currentYear - 1,
          start.getMonth(),
          start.getDate(),
          start.getHours(),
          start.getMinutes(),
          start.getSeconds(),
        );
      }

      const diffInMs = now.getTime() - fromDate.getTime();
      this.days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
      if (this.days === 1) {
        // @ts-ignore
        this.daysText = this.translates.day ?? 'Day';
      } else {
        // @ts-ignore
        this.daysText = this.translates.days ?? 'Days';
      }
    },
  }));
}
